import { Sun, Moon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTheme } from '@/contexts/ThemeContext';
import { colors, getNeumorphicShadow, getNeumorphicInset } from '@/lib/designSystem';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const currentColors = colors[theme];

  return (
    <motion.button
      onClick={toggleTheme}
      className="relative w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300"
      style={
        {
          background: currentColors.cardBg,
          boxShadow: getNeumorphicShadow(theme),
        }
      }
      whileHover={{ scale: 1.05 }}
      whileTap={
        {
          scale: 0.95,
          boxShadow: getNeumorphicInset(theme),
        }
      }
      aria-label="Toggle theme"
    >
      <motion.div
        initial={false}
        animate={
          {
            rotate: isDark ? 180 : 0,
            scale: isDark ? 1 : 0.8,
          }
        }
        transition={{ duration: 0.3 }}
      >
        {isDark ? (
          <Moon size={20} style={{ color: currentColors.accentBlue }} />
        ) : (
          <Sun size={20} style={{ color: currentColors.accentOrange }} />
        )}
      </motion.div>
    </motion.button>
  );
};

export default ThemeToggle;
